import axios from 'axios';

import { BASE_URL, INSURANCES_BASE_URL, VENDER_BASE_URL } from './constants';

function getToken() {
  return sessionStorage.getItem('token');
}

axios.interceptors.request.use(config => {
  const newConfig = config;

  if (!getToken()) return (window.location.href = '/login');

  if (
    config.url.includes(BASE_URL) ||
    config.url.includes(INSURANCES_BASE_URL) ||
    config.url.includes(VENDER_BASE_URL)
  ) {
    newConfig.headers.Authorization = `Bearer ${getToken()}`;
  }
  return newConfig;
});

axios.interceptors.response.use(
  response => response.data,
  error => Promise.reject(error)
);

export default axios;
